import { gql } from '@moonpig/web-core-graphql'

const PRODUCT_SEARCH_FIELDS_FRAGMENT = gql`
  fragment SearchServiceProductVariant on ProductVariant {
    key
    title
    subtitle
    inStock
    sku
    minimumQuantity
    price {
      centAmount
      currencyCode
      fractionDigits
    }
    fullPrice {
      centAmount
      currencyCode
      fractionDigits
    }
    discountedPercentage
    dimensions {
      description
    }
    capabilities {
      video
    }
  }

  fragment SearchServiceAddon on Addon {
    title
    description
    sku
    inStock
    price {
      display
      centAmount
      currencyCode
    }
    image {
      url
    }
  }

  fragment SearchServiceProductDynamicImages on Product {
    appliedIntents {
      intentId
      value
      ordinal
    }
    dynamicImages {
      intentKey
      large {
        webp {
          title
          url
        }
      }
      medium {
        webp {
          title
          url
        }
      }
    }
  }

  fragment MultiBuyListFragment on Product {
    multiBuyList {
      count
    }
  }

  fragment SearchServiceProduct on Product {
    id
    title
    slug
    dependencies
    customisable
    isLandscape
    clickRankDocumentCount
    category {
      id
      slug
      name
      department
    }
    range {
      key
    }
    rating {
      count
      score
    }
    masterVariant {
      ...SearchServiceProductVariant
      productImages {
        mainImage {
          medium {
            jpgUrl
          }
        }
        images {
          small {
            jpgUrl
          }
          medium {
            jpgUrl
          }
          large {
            jpgUrl
          }
        }
      }
      addons(clientUsesDescription: true) {
        ...SearchServiceAddon
      }
    }
    variants {
      ...SearchServiceProductVariant
      addons(clientUsesDescription: true) {
        ...SearchServiceAddon
      }
    }
    hasAugmentedReality
    productPills {
      displayLabel
      displayVariant
    }
    primaryProductPill {
      displayLabel
      displayVariant
    }
    publishDate
    isSponsored
  }
`

export const ProductSearchGQL = gql`
  query SearchServiceProductSearch(
    $searchTerm: String!
    $limit: Int!
    $offset: Int!
    $filters: CriteriaInput!
    $department: [DepartmentsEnum!]
    $returnSuggestions: Boolean!
    $experimentValues: String
    $platform: Platform
    $nbaAlgorithm: String
    $sortOrder: SortOrder
    $sponsoredProducts: [SponsoredProductInput!]
    $isInitialQuery: Boolean!
    $useSmartDepartmentRedirection: Boolean!
    $multiBuyExperimentEnabled: Boolean = false
  ) {
    productSearch(
      searchTerm: $searchTerm
      department: $department
      limit: $limit
      offset: $offset
      filters: $filters
      experimentValues: $experimentValues
      platform: $platform
      nbaAlgorithm: $nbaAlgorithm
      sortOrder: $sortOrder
      sponsoredProducts: $sponsoredProducts
      isInitialQuery: $isInitialQuery
      useSmartDepartmentRedirection: $useSmartDepartmentRedirection
    ) {
      totalClickRankDocumentCount
      appliedIntents {
        intentId
        ordinal
        value
      }
      departmentCounts {
        ... on AlternativeSearchDepartmentCount {
          department
          count
          label
        }
      }
      count
      redirectedDepartment
      products {
        ...SearchServiceProduct
        ...SearchServiceProductDynamicImages
        ...SearchServiceProductDynamicImages
        ...MultiBuyListFragment @include(if: $multiBuyExperimentEnabled)
      }
      suggestions @include(if: $returnSuggestions) {
        ...SearchServiceProduct
        ...SearchServiceProductDynamicImages
      }
      spellingCorrection {
        initialSearchTerm
        correctedSearchTerm
      }
      supportedSortOrders {
        displayText
        isDefault
        value
      }
      isMultiBuySupported
    }
  }
  ${PRODUCT_SEARCH_FIELDS_FRAGMENT}
`
